export default __webpack_public_path__ + "static/Oxygen-Complete-Rate-Card-2-Novmber-2022-94f7cf0f74e3fe64f4736225dd164a5f.pdf";